import { inject, Injectable, signal } from '@angular/core';
import { ComesaApiService } from '../../features/comesa/services/comesa-api.service';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateAlertService {
  private api = inject(ComesaApiService);

  readonly hasNoRateForToday = signal<boolean>(false);

  checkTodayRate(): void {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const todayStr = `${y}-${m}-${day}`;

    this.api.getExchangeRates({ effectiveDate: todayStr, pageSize: '1' }).subscribe({
      next: page => {
        const hasRate = !!(page?.items && page.items.length > 0);
        this.hasNoRateForToday.set(!hasRate);
      },
      error: () => {
        this.hasNoRateForToday.set(false);
      },
    });
  }
}
